<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/reports"></ion-back-button>
    </ion-buttons>

    <smr-stylist-picker
      [stylistID]="stylistID"
      [readOnly]="readOnlyStylistPicker"
      [showAllStaff]="true"
      (onInit)="onStylistPickerInit($event)"
      (stylistSelect)="onStylistSelect($event)"
      cssClass="smr-stylist-picker-for-salesreport"
    >
    </smr-stylist-picker>
  </ion-toolbar>
  <ion-toolbar>
    <salonmonster-date-picker
      [startDate]="startDate"
      [endDate]="endDate"
      [disabled]="isLoading"
      (rangeChanged)="rangeChanged($event)"
    ></salonmonster-date-picker>
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylistPicker || errorOccurredWhileLoadingStats"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>

  <ng-container
    *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker && !errorOccurredWhileLoadingStats"
  >
    <!--show all staff breakdown -->
    <ion-row *ngIf="stylist.getID() == 0">
      <ion-col> </ion-col>
    </ion-row>
    <ion-slides pager [options]="slideConfig">
      <ion-slide>
        <ion-col size="12">
          <div
            style="
              margin-bottom: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <canvas
              baseChart
              [data]="barChartData"
              [type]="barChartType"
              [options]="barChartOptions"
            ></canvas>
          </div>
        </ion-col>
      </ion-slide>

      <ion-slide>
        <ion-col size="12" size-md="12">
          <div
            style="
              margin-bottom: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
              
            "
          >
            <canvas
              baseChart
              [data]="radarChartData"
              [options]="radarChartOptions"
              [type]="radarChartType"

            ></canvas>
          </div>
        </ion-col>
      </ion-slide>

      <ion-slide>
        <ion-col size="12" size-md="12">
          <div
            style="
              margin-bottom: 30px;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <canvas
              baseChart
              [data]="barChartDataCustomersByTime"
              [options]="barChartOptionsCustomersByTime"
              [type]="barChartTypeCustomersByTime"
            ></canvas>
          </div>
        </ion-col>
      </ion-slide>
    </ion-slides>

    <ion-toolbar class="ion-no-padding">
      <ion-buttons class="tab-group">
        <ion-button
          [ngClass]="{ 'tab-checked': tab == 'totals' }"
          class="tab-button"
          (click)="tab = 'totals'"
          >Totals</ion-button
        >
        <ion-button
          [ngClass]="{ 'tab-checked': tab == 'averages' }"
          class="tab-button"
          (click)="tab = 'averages'"
          >Averages</ion-button
        >
      </ion-buttons>
    </ion-toolbar>
    <p-table
      *ngIf="stylist.getID() === 0"
      [hidden]="tab != 'totals'"
      styleClass="sticky-table"
      [columns]="colsStaffBreakdown"
      [value]="staffBreakdownStats"
      sortMode="multiple"
      [responsive]="true"
    >
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <h4>Sales by Staff member</h4>
          <div class="ui-align-items">
            <span class="export">Export to:</span>
            <ion-button
              fill="outline"
              (click)="exportExcel('colsStaffBreakdown')"
              style="margin-right: 0.5em"
              >Excel</ion-button
            >
            <ion-button
              fill="outline"
              (click)="exportPdf('colsStaffBreakdown')"
            >
              PDF
            </ion-button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            <div [ngClass]="{'text-align-center': col.field !=='timestamp'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td
            [ngClass]="{'center-numbers-table': col.field !=='timestamp'}"
            *ngFor="let col of columns"
          >
            {{col.field === "stylistFullName" ? (stat[col.field]) :
            (stat[col.field] | salonMonsterCurrency)}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td><strong>Total</strong></td>
          <td class="center-numbers-table">
            {{ summaryServicesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryRetailCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryPreTaxCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryTaxesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summarySalesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryTipsCol() | salonMonsterCurrency }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-table
      [hidden]="tab != 'totals'"
      styleClass="sticky-table"
      [columns]="cols"
      [value]="stats"
      sortMode="multiple"
      [responsive]="true"
    >
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <h4>Sales by Date</h4>
          <div class="ui-align-items">
            <span class="export">Export to:</span>
            <ion-button
              fill="outline"
              (click)="exportExcel('cols')"
              style="margin-right: 0.5em"
              >Excel</ion-button
            >
            <ion-button fill="outline" (click)="exportPdf('cols')">
              PDF
            </ion-button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            <div [ngClass]="{'text-align-center': col.field !=='timestamp'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td
            [ngClass]="{'center-numbers-table': col.field !=='timestamp'}"
            *ngFor="let col of columns"
          >
            {{col.field === "timestamp" ? (stat[col.field]) : (stat[col.field] |
            salonMonsterCurrency)}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td><strong>Total</strong></td>
          <td class="center-numbers-table">
            {{ summaryServicesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryRetailCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryPreTaxCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryTaxesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summarySalesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryTipsCol() | salonMonsterCurrency }}
          </td>
        </tr>
      </ng-template>
    </p-table>
    <!-- <p-table
      *ngIf="stylist.getID() === 0"
      [hidden]="tab != 'averages'"
      styleClass="sticky-table"
      [columns]="colsStaffBreakdown"
      [value]="staffBreakdownStats"
      sortMode="multiple"
      [responsive]="true"
    >
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <h4>Sales by Staff members</h4>
          <div class="ui-align-items">
            <span class="export">Export to:</span>
            <ion-button
              fill="outline"
              (click)="exportExcel('colsStaffBreakdown')"
              style="margin-right: 0.5em"
              >Excel</ion-button
            >
            <ion-button
              fill="outline"
              (click)="exportPdf('colsStaffBreakdown')"
            >
              PDF
            </ion-button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            <div [ngClass]="{'text-align-center': col.field !=='timestamp'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td
            [ngClass]="{'center-numbers-table': col.field !=='timestamp'}"
            *ngFor="let col of columns"
          >
            {{col.field === "stylistFullName" ? (stat[col.field]) :
            (stat[col.field] | salonMonsterCurrency)}}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr>
          <td><strong>Total</strong></td>
          <td class="center-numbers-table">
            {{ summaryServicesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryRetailCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryPreTaxCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryTaxesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summarySalesCol() | salonMonsterCurrency }}
          </td>
          <td class="center-numbers-table">
            {{ summaryTipsCol() | salonMonsterCurrency }}
          </td>
        </tr>
      </ng-template>
    </p-table> -->
    <p-table
      [hidden]="tab != 'averages'"
      styleClass="sticky-table"
      [columns]="colsAvg"
      [value]="stats"
      sortMode="multiple"
      [responsive]="true"
    >
      <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix">
          <h4>Sales by Date</h4>
          <div class="ui-align-items">
            <span class="export">Export to:</span>
            <ion-button
              fill="outline"
              (click)="exportExcel('cols')"
              style="margin-right: 0.5em"
              >Excel</ion-button
            >
            <ion-button fill="outline" (click)="exportPdf('cols')">
              PDF
            </ion-button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            <div [ngClass]="{'text-align-center': col.field !=='timestamp'}">
              {{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stat let-columns="columns">
        <tr>
          <td
            [ngClass]="{'center-numbers-table-medium-padding': col.field !=='timestamp'}"
            *ngFor="let col of columns"
          >
            {{col.field === "timestamp" ? (stat[col.field]) : (stat[col.field] |
            salonMonsterCurrency)}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</ion-content>
